import React from 'react'
import NumberFormat  from 'react-number-format'

export const numberFormat = (value, allowNegative = false,decimalScale=2) => {
  return (
  <NumberFormat 
    className='centerContent' 
    thousandSeparator=',' 
    value={value} 
    displayType='text'
    decimalScale={decimalScale}
    allowNegative={allowNegative}
    fixedDecimalScale />
  )
}

export const documentType = () => {
  return ([
    {
      code:'CH02',
      name:'Other',
      isRequire:false
    }
  ])
}

export const validateField = (values,actionName=null) => {
  let errors = {}
  if(actionName=='cancel'||actionName=='revise'){
    if (!values.actionComment) {
      errors.actionComment = 'Required!'
    }
  }else{
    if (!values.title) {
      errors.title = 'Required!'
    }
    if (values.title && values.title.length > 200) {
      errors.title = 'Title must be less than or equal to 200 characters'
    }
    if (!values.projectId) {
      errors.projectId = 'Required!'
    }
    if (!values.requesterUser) {
      errors.requesterUser = 'Required!'
    }
    if (!values.documentDate) {
      errors.documentDate = 'Required!'
    }
    if (!values.poSelect) {
      errors.poSelect = 'Required!'
    }
    if (!values.priority) {
      errors.priority = 'Required!'
    }
    if(!values.requestTypes||values.requestTypes.length==0){
      errors.requestTypeCheck = 'Required!'
    }else{
      let requestTypesNonDelete = values.requestTypes.filter(x=>!x.deleted)
      if(requestTypesNonDelete.length==0){
        errors.requestTypeCheck = 'Required!'
      }else{
        requestTypesNonDelete.forEach(x => {
          if(!x.deleted){
            if(!x.code){
              errors.requestTypeCheck = 'Required!'
            }else if(!x.description || (x.description&&!x.description.trim())){
              errors.requestTypeCheck = 'Required!'
            }
          }
        })
      }
    }
  }
  return errors
}
